import axios from "../utils/axios";

export const getAllHotelExtras = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("hotel-extras", { params });
    return data;
};

export const getHotelExtra = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`hotel-extras/${id}`);
    return data;
};

export const createHotelExtra = async (req) => {
    try {
        const { data } = await axios.post("hotel-extras", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createHotelExtra error:", error);
        throw error;
    }
};

export const updateHotelExtra = async (req, id) => {
    try {
        const { data } = await axios.put(`hotel-extras/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateHotelExtra error:", error);
        throw error;
    }
};

export const deleteHotelExtra = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-extras/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteHotelExtra error:", error);
        throw error;
    }
};

export const deleteAllHotelExtras = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-extras/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllHotelExtras error:", error);
        throw error;
    }
};

export const restoreHotelExtra = async (id) => {
    try {
        const { data } = await axios.post(`hotel-extras/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreHotelExtra error:", error);
        throw error;
    }
};

export const restoreAllHotelExtras = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "hotel-extras/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllHotelExtras error:", error);
        throw error;
    }
};

export const forceDeleteHotelExtra = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-extras/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteHotelExtra error:", error);
        throw error;
    }
};

export const forceDeleteAllHotelExtras = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-extras/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllHotelExtras error:", error);
        throw error;
    }
};

export const getHotelExtrasForSelect = async () => {
    try {
        const { data } = await axios.get("hotel-extras/for-select");
        return data;
    } catch (error) {
        console.error("getHotelExtrasForSelect error:", error);
        throw error;
    }
};
